// extracted by mini-css-extract-plugin
export default {"messagesWrapper":"Messages_messagesWrapper__V6aHl","conversation":"Messages_conversation__hY35H","messagesScrollBtn":"Messages_messagesScrollBtn__sBWdn"};